export enum CourseItemConfig {
    showAll,
    showEnrolled
}